import { defineStore } from 'pinia';
import { storage } from '@/utils'
import { update } from 'lodash';
export const useUserStore = defineStore('user', {
  // id: 'user', // id必填，且需要唯一。两种写法
  state: () => {
    return {
      name: '张三',
      islogin: false,
      deferredPrompt: {},
      nextStaus22: 2,
      showOpenApp: true,
      isInstalled:false
    };
  },
  getters: {
    nameLength: (state) => state.name.length,
    loginStatus: (state) => state.islogin || storage.getItem('userToken'),
  },
  actions: {
    updateName(name: string) {
      this.name = name;
    },
    updateLoginStatus(token: any) {
      this.islogin = token ? true : false
    },
    updateDeferredPrompt(val: any) {
       this.deferredPrompt = val
    },
    updateNextStaus22(val: any) {
       this.nextStaus22 = val
    },
    updateShowOpenApp(val: boolean) {
       this.showOpenApp = val
    },
    updateIsInstalled(val: boolean) {
       this.isInstalled = val
    }
  },
});
